import {ErrorStateMatcher} from '@angular/material/core';
import {AbstractControl, FormGroupDirective, NgForm} from '@angular/forms';

export class InstantErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: AbstractControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return control && control.invalid;
  }
}

export const InstantErrorStateMatcherInstance = new InstantErrorStateMatcher();
